export default {
      id: "ic_not_login_winlost-usage",
      viewBox: "0 0 30 31",
      url: "/" + "images/icons.3.109.2.svg#ic_not_login_winlost-usage",
      toString: function () {
        return this.url;
      }
    }